import { render, staticRenderFns } from "./MRC_ESS_Microsoft_FileDragUpdate.vue?vue&type=template&id=a6b13c16&"
import script from "./MRC_ESS_Microsoft_FileDragUpdate.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_Microsoft_FileDragUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VFileInput,VProgressLinear,VRow,VSheet,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b13c16')) {
      api.createRecord('a6b13c16', component.options)
    } else {
      api.reload('a6b13c16', component.options)
    }
    module.hot.accept("./MRC_ESS_Microsoft_FileDragUpdate.vue?vue&type=template&id=a6b13c16&", function () {
      api.rerender('a6b13c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_Microsoft_FileDragUpdate.vue"
export default component.exports